// 設計 https://qiita.com/Yama-Tomo/items/9cc0836a9cfeb5044105#1-%E3%82%B9%E3%83%86%E3%83%BC%E3%83%88%E3%81%B8%E3%81%AE%E3%82%A2%E3%82%AF%E3%82%BB%E3%82%B9%E3%82%92%E3%82%BF%E3%82%A4%E3%83%97%E3%82%BB%E3%83%BC%E3%83%95%E3%81%AB%E3%81%99%E3%82%8B
// [Vue CLI 3\.0 で TypeScript な Vue\.js プロジェクトをつくってみる \- Qiita](https://qiita.com/nunulk/items/7e20d6741637c3416dcd#43-store)

import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { NSInterview } from '@/types/Interview';

type InterviewState = {
  posts: NSInterview.Interview[];
};

const state: InterviewState = {
  posts: window.gmj.interview.posts ? window.gmj.interview.posts : []
};

const getters: GetterTree<InterviewState, RootState> = {
  getPosts(state: InterviewState) {
    return state.posts;
  }
};

const mutations: MutationTree<InterviewState> = {
  /**
   * postsにPost[]を格納する
   * @param state
   * @param posts
   */
  setPosts(state: InterviewState, posts: NSInterview.Interview[]) {
    state.posts = posts;
  }
};

const actions: ActionTree<InterviewState, RootState> = {
  setPosts({ commit }, posts: NSInterview.Interview[] = []) {
    commit('setPosts', posts);
  }
};

//  https://github.com/vuejs/vuex/blob/dev/types/index.d.ts#L111
export const interview: Module<InterviewState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
